import metrics from '~/data/marketingRouterRuleMetrics.json';

import type {
  MarketingRouterMetricName,
  MarketingRouterRuleMetricValues,
  MarketingRouterRuleMetrics,
} from '~/types/marketingRouterRuleMetrics';

const METRIC_NAMES: Array<MarketingRouterMetricName> = ['ttv', 'margin_aud', 'sessions', 'conversion'];

function getMetricValue(record: MarketingRouterRuleMetrics, name: MarketingRouterMetricName): number {
  return record.metrics.find((metric) => metric.name === name)?.value ?? 0;
}

export function getMarketingRouterRuleMetrics(ruleId: string, variantId: string): MarketingRouterRuleMetricValues {
  const record = (metrics as Array<MarketingRouterRuleMetrics>).find(
    (candidate) => candidate.rule_id === ruleId && candidate.variant_id === variantId,
  );

  return {
    rule_id: ruleId,
    variant_id: variantId,
    ...Object.fromEntries(METRIC_NAMES.map((name) => [name, record ? getMetricValue(record, name) : 0])),
    significance: record?.significance ?? 'pending',
  } as MarketingRouterRuleMetricValues;
}
